import { create } from 'zustand';
import type { StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

export const createStore = <T>(
  storeName: string,
  initializer: StateCreator<T, [['zustand/devtools', never]]>
) =>
  create<T>()(
    devtools(initializer, {
      enabled: true,
      name: 'MerchUI',
      store: storeName
    })
  );
